var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"checkout-h3 confirmation-subtitle"},[_vm._v(_vm._s(_vm.delivery.name))]),_c('p',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.delivery.summary))])])}
var staticRenderFns = []

export { render, staticRenderFns }